import { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  TextInput,
  ScrollView,
  Platform,
  Modal,
  useWindowDimensions,
  ActivityIndicator,
} from 'react-native';
import TopGreenHeader from '../Common/TopGreenHeader';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateHelperFn } from '../Common/helper';
import { getAllAddressCreator } from '../../slices/authSlice';
import { ToastContainer, toast } from 'react-toastify';
import AsyncStorage from '@react-native-async-storage/async-storage';
import API_PATHS from '../../apiCalls/ApiPath';
import axios from 'axios';

// Internal CSS for react-toastify
const toastifyCss = `
.Toastify__toast-container {
  z-index: 9999;
  font-family: sans-serif;
}
.Toastify__toast {
  border-radius: 4px;
  padding: 16px;
  font-size: 16px;
}
.Toastify__progress-bar {
  background: #A6CE39;
}
`;

const ConfirmBooking = ({ route }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { width: windowWidth } = useWindowDimensions();
  // On wide screens (desktop web) lay the summary cards out in two columns.
  const isWideScreen = windowWidth >= 768;
  const [notes, setNotes] = useState('');
  const kidsSelected = useSelector(state => state.auth.kidsSelected);
  const serviceScheduled = useSelector(state => state.auth.serviceScheduled);
  const planChoosed = useSelector(state => state.auth.planChoosed);
  const daysSelected = useSelector(state => state.auth.daysSelected);
  const kidsByDay = useSelector(state => state.auth.kidsByDay);
  const selectedAddressData = useSelector(state => state.auth.selectedAddress);
  const selectedAddress = useState(selectedAddressData);
  const parentId = useSelector(state => state.auth.parentId);
  const getLocation = useSelector(state => state.auth.getgetAllLocation);
  const getAllPlans = useSelector(state => state.auth.getAllPlans);
  const [sendSpecialInstructions, setSendSpecialInstructions] = useState(true);
  const [instructions, setInstructions] = useState("");
  const [tempInstructions, setTempInstructions] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  console.log("selected addresses", selectedAddressData);

  const {
    formattedDate,
    service,
    formattedTime,
    serviceName,
    bookingType,
    location,
  } = serviceScheduled;

  // localStorage only exists on web; native reads auth from redux/AsyncStorage
  const authUserId = useSelector(state => state.auth.userId);
  const authToken = useSelector(state => state.auth.token);
  const authUserType = useSelector(state => state.auth.userType);
  const isWeb = Platform.OS === 'web';
  const userId = isWeb ? localStorage.getItem('userId') : authUserId;
  const token = isWeb ? localStorage.getItem('token') : authToken;
  const clientToken = isWeb ? localStorage.getItem('clientToken') : null;
  const clientId = isWeb ? localStorage.getItem('clientId') : null;

  const fetchUserData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_PATHS.BASE_URL}${API_PATHS.PROFILE_API}/${clientId || userId}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${clientToken || token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await response.json();
      if (data.Success === 1 && data.Data.response.parent) {
        const parentData = data.Data.response.parent;
        setInstructions(parentData.discription || '');
        console.log("here are instructions", parentData.discription);
      } else {
        toast.error('Something went wrong! Please try again later');
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      toast.error('Something went wrong while fetching data');
    } finally {
      setLoading(false);
    }
  }, [userId, clientId, clientToken, token]);

  const handleEditInstructions = () => {
    const userType = isWeb ? localStorage.getItem("userType") : authUserType;
    if (userType == 'admin' || userType === '"admin"') {
      toast.error("You are not allowed to edit client instructions");
      return;
    }
    setTempInstructions(instructions);
    setModalVisible(true);
  };

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);


  console.log("Service Name", serviceName);

  const {
    choseedPlanName,
    planId,
    planType,
    planService,
    socialHubDayPlans,
    price: planPrice,
    numOfKids: planNumKids,
    isFixedWeekdays,
  } = planChoosed;

  const isSocialHub = planService === 'SOCIALHUB';
  const isRecurring = bookingType === 'Recurring';

  // Friendly, customer-facing labels for the raw service / plan-service codes.
  const SERVICE_LABELS = {
    HOMECARE: 'Home Care',
    LEARNCARE: 'Social Hub',
    TRANSLEARN: 'Breakfast Club',
    TRANSPORT: 'Transport',
    BIRTHDAY: 'Birthday Party',
    VENREN: 'Venue Rental',
    SOCIALHUB: 'Social Hub',
    BREAKFASTCLUB: 'Breakfast Club',
  };
  const serviceLabel =
    SERVICE_LABELS[planService] || SERVICE_LABELS[serviceName] || service || serviceName;
  // A day-by-day kid mapping exists for the day-selection flow; the fixed
  // Mon-Fri flow (Breakfast Club) only sets daysSelected + kidsSelected.
  const hasPerDayKids = kidsByDay && Object.keys(kidsByDay).length > 0;

  // For Social Hub the per-day price depends on how many kids are on that day,
  // so look the plan up by kid count (same rule used on SelectDaysScreen).
  const socialHubPlanByKidCount = {};
  if (isSocialHub) {
    (getAllPlans?.Data || [])
      .filter(p => p.service === 'SOCIALHUB')
      .forEach(p => {
        socialHubPlanByKidCount[p.noOfKid] = p;
      });
  }

  const getDayPrice = day => {
    const dayKids = (kidsByDay && kidsByDay[day]) || [];
    if (isSocialHub) {
      const matched = socialHubPlanByKidCount[dayKids.length];
      return matched ? Number(matched.price) : 0;
    }
    return Number(planPrice) || 0;
  };

  const socialHubGrandTotal = isSocialHub
    ? daysSelected.reduce((sum, day) => sum + getDayPrice(day), 0)
    : 0;

  const locationId = getLocation?.Data?.locations.find(
    loc => loc.name === location,
  )?.locationId;

  const handleInputChange = text => {
    setNotes(text);
  };

  useEffect(() => {
    dispatch(getAllAddressCreator());
  }, [dispatch]);

  const handleSubmit = async () => {

    if (!notes.trim()) {
      toast.error('Please enter some notes before submitting.');
      return;
    }

    try {
      const token = await AsyncStorage.getItem('token');
      const clientToken = await AsyncStorage.getItem('clientToken');

      let response;

      const [day, month, year] = formattedDate.split('/').map(Number);

      const times = formattedTime.split(' - ');
      const startTime = times[0];
      const endTime = times.length > 1 ? times[1] : times[0];

      const startDateTime = new Date(
        year,
        month - 1,
        day,
        ...startTime.split(':').map(Number),
      );
      const endDateTime = new Date(
        year,
        month - 1,
        day,
        ...endTime.split(':').map(Number),
      );

      const startTimestamp = Math.floor(startDateTime.getTime() / 1000);
      const endTimestamp = Math.floor(endDateTime.getTime() / 1000);

      if (bookingType === 'Recurring' && planService === 'SOCIALHUB') {
        // Social Hub uses a dedicated endpoint with per-day kids & planId.
        const endTimestampSH = startTimestamp + 30 * 24 * 60 * 60; // ~30 days
        const days = daysSelected.map(day => ({
          weekDay: day,
          planId: (socialHubDayPlans && socialHubDayPlans[day]) || planId,
          kids: (kidsByDay[day] || []).map(kid => kid.kidId),
        }));
        const socialHubData = {
          locationId: locationId,
          startDate: startTimestamp,
          endDate: endTimestampSH,
          bookingType: 'Weekly',
          comment: notes,
          days,
        };
        response = await fetch(
          `${API_PATHS.BASE_URL}${API_PATHS.CREATE_RECURRING_SOCIALHUB}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              authorization: `Bearer ${clientToken || token}`,
            },
            body: JSON.stringify(socialHubData),
          },
        );
      } else if (bookingType === 'Recurring') {
        const recurringData = {
          planId: planId,
          kids: kidsSelected.map(kid => kid.kidId),
          parentId: parentId,
          bookingType: planType === 1 ? 'Daily' : 'Weekly',
          locationId: locationId,
          startDate: startTimestamp,
          addresses: selectedAddress.flat().filter(item => item && item.tag),
          // Send the plan-service code: Transport -> TRANSPORT, Breakfast Club
          // -> BREAKFASTCLUB (raw serviceName is TRANSLEARN). Falls back to
          // serviceName if planService is ever missing.
          type: planService || serviceName,
          // Breakfast Club (TRANSLEARN) runs a fixed Mon-Fri week, so it sends an
          // empty weekDays array; every other recurring service sends the picks.
          weekDays:
            serviceName === 'TRANSLEARN' || isFixedWeekdays ? [] : daysSelected,
          comment: notes,
        };
        response = await fetch(
          `${API_PATHS.BASE_URL}${API_PATHS.CREATE_RECURRING}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              authorization: `Bearer ${clientToken || token}`,
            },
            body: JSON.stringify(recurringData),
          },
        );
      } else {
        const adhocData = {
          // Social Hub is represented internally as LEARNCARE, but the API
          // expects the SOCIALHUB type code for adhoc bookings.
          type: serviceName === 'LEARNCARE' ? 'SOCIALHUB' : serviceName,
          endTime: endTimestamp,
          comment: notes,
          bookingDateTime: startTimestamp,
          locationId: locationId,
          addresses: selectedAddress.flat().filter(item => item && item.tag),
          kids: kidsSelected.map(kid => kid.kidId),
          startTime: startTimestamp,
        };
        response = await fetch(
          `${API_PATHS.BASE_URL}${API_PATHS.CREATE_BOOKING}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              authorization: `Bearer ${clientToken || token}`,
            },
            body: JSON.stringify(adhocData),
          },
        );
      }

      const result = await response.json();
      if (result.Success === 1) {
        toast.success(result.Message);
        setTimeout(() => {
          navigation.navigate('ScheduleService');
        }, 3000);
      } else {
        throw new Error(result.Message || 'An error occurred');
      }
    } catch (error) {
      toast.error(
        error.message || 'An error occurred while creating the booking',
      );
    }
  };

  function toCapital(input) {
    if (!input || typeof input !== 'string') {
      return input;
    }
    return input.toUpperCase();
  }

  function formattedTimefnc(time) {
    if (time.includes('-')) {
      const [startTime, endTime] = time.split(' - ');
      return `${formatSingleTime(startTime)} - ${formatSingleTime(endTime)}`;
    }
    return formatSingleTime(time);
  }

  function formatSingleTime(time) {
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  const formatGender = gender =>
    gender === 'BOY' ? 'Boy' : gender === 'GIRL' ? 'Girl' : gender;

  // A single line "label: value" row used across the summary cards.
  const renderInfoRow = (label, value) => (
    <View style={styles.infoRow}>
      <Text style={styles.infoLabel}>{label}</Text>
      <Text style={styles.infoValue}>{value}</Text>
    </View>
  );

  const renderKidRow = kid => (
    <View key={kid.id ?? kid.kidId} style={styles.kidRow}>
      <Image
        source={
          kid.profilePic
            ? { uri: kid.profilePic }
            : require('../../assets/AddKidPic.png')
        }
        style={styles.kidAvatar}
      />
      <View style={{ flex: 1 }}>
        <Text style={styles.kidName}>{kid.name}</Text>
        <Text style={styles.kidDetails}>
          {kid.age} years{kid.gender ? `, ${formatGender(kid.gender)}` : ''}
        </Text>
      </View>
    </View>
  );

  // Service + schedule overview, shown for every booking type.
  const renderScheduleCard = () => (
    <View style={styles.card}>
      <Text style={styles.cardLabel}>Service</Text>
      <Text style={styles.cardTitle}>{serviceLabel}</Text>
      {renderInfoRow('Booking', isRecurring ? 'Recurring' : 'One-time')}
      {isRecurring
        ? renderInfoRow('Starts from', formatDateHelperFn(formattedDate))
        : (
          <>
            {renderInfoRow('Date', formatDateHelperFn(formattedDate))}
            {formattedTime
              ? renderInfoRow('Time', formattedTimefnc(formattedTime))
              : null}
          </>
        )}
      {location ? renderInfoRow('Location', location) : null}
    </View>
  );

  // Plan details, only relevant for recurring bookings.
  const renderPlanCard = () => {
    if (!isRecurring || !choseedPlanName) {
      return null;
    }
    return (
      <View style={styles.card}>
        <Text style={styles.cardLabel}>Selected Plan</Text>
        <Text style={styles.cardTitle}>{choseedPlanName}</Text>
        {planType ? renderInfoRow('Plan', planType) : null}
        {planNumKids
          ? renderInfoRow(
              'Capacity',
              `${planNumKids} ${planNumKids > 1 ? 'children' : 'child'}`,
            )
          : null}
        {!isSocialHub && planPrice != null
          ? renderInfoRow('Price', `$${Number(planPrice).toFixed(2)}/month`)
          : null}
      </View>
    );
  };

  // Schedule + plan cards: side-by-side on wide screens, stacked otherwise.
  const renderTopCards = () => {
    const planCard = renderPlanCard();
    if (isWideScreen && planCard) {
      return (
        <View style={styles.topRow}>
          <View style={styles.topRowItem}>{renderScheduleCard()}</View>
          <View style={styles.topRowItem}>{planCard}</View>
        </View>
      );
    }
    return (
      <>
        {renderScheduleCard()}
        {planCard}
      </>
    );
  };

  // Days + the kids chosen for each, the core of the new preview.
  const renderDaysAndKids = () => {
    // One-time bookings: just the chosen children.
    if (!isRecurring) {
      return (
        <View style={styles.card}>
          <Text style={styles.cardLabel}>Selected Children</Text>
          {kidsSelected.map(renderKidRow)}
        </View>
      );
    }

    // Fixed Mon-Fri plans (Breakfast Club) or any flow without a per-day map:
    // show the days as chips and the kids once.
    if (isFixedWeekdays || !hasPerDayKids) {
      return (
        <View style={styles.card}>
          <Text style={styles.cardLabel}>Days</Text>
          <View style={styles.chipRow}>
            {daysSelected.map(day => (
              <View key={day} style={styles.dayChip}>
                <Text style={styles.dayChipText}>{day}</Text>
              </View>
            ))}
          </View>
          <Text style={[styles.cardLabel, { marginTop: 14 }]}>Children</Text>
          {kidsSelected.map(renderKidRow)}
        </View>
      );
    }

    // Day-by-day breakdown with the kids (and per-day price for Social Hub).
    return (
      <>
        <Text style={styles.sectionHeader}>Schedule</Text>
        {daysSelected.map(day => {
          const dayKids = (kidsByDay && kidsByDay[day]) || [];
          return (
            <View key={day} style={styles.card}>
              <View style={styles.dayHeaderRow}>
                <Text style={styles.dayTitle}>{day}</Text>
                {isSocialHub && (
                  <Text style={styles.dayPrice}>
                    ${getDayPrice(day).toFixed(2)}
                  </Text>
                )}
              </View>
              {dayKids.length > 0 ? (
                dayKids.map(renderKidRow)
              ) : (
                <Text style={styles.kidDetails}>No children selected</Text>
              )}
            </View>
          );
        })}
        {isSocialHub && (
          <View style={styles.grandTotalCard}>
            <Text style={styles.grandTotalText}>Grand Total</Text>
            <Text style={styles.grandTotalAmount}>
              ${socialHubGrandTotal.toFixed(2)}/month
            </Text>
          </View>
        )}
      </>
    );
  };

  const renderAddresses = () => {
    const addresses = (selectedAddress?.flat() || []).filter(
      item => item && item.tag,
    );
    if (addresses.length === 0) {
      return null;
    }
    return (
      <View style={styles.card}>
        <Text style={styles.cardLabel}>
          {addresses.length > 1 ? 'Addresses' : 'Address'}
        </Text>
        {addresses.map(item => (
          <View key={item.id} style={styles.addressRow}>
            <Text style={styles.addressTag}>{toCapital(item.tag)}</Text>
            <Text style={styles.addressText}>
              {item.houseno ? item.houseno + ', ' : ''}
              {item.area}, {item.city} - {item.zipcode}
            </Text>
          </View>
        ))}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' && <style>{toastifyCss}</style>}
      <ScrollView style={styles.scrollView}>
        <TopGreenHeader
          Heading={'Confirm Booking'}
          navigation={navigation}
          isBackIcon={true}
          isNotification={false}
        />
        {loading ? (
          <ActivityIndicator size="large" color="#A6CE39" style={{ marginTop: 20 }} />
        ) : (
          <View style={styles.content}>
            <Text style={styles.previewHeading}>Booking Preview</Text>
            <Text style={styles.previewSubHeading}>
              Please review the details below before confirming.
            </Text>

            {renderTopCards()}
            {renderDaysAndKids()}
            {renderAddresses()}

            <View style={styles.inputContainer}>
              <TextInput
                style={styles.input}
                placeholder="Add any special notes or requirements..."
                placeholderTextColor="#aaa"
                multiline
                value={notes}
                onChangeText={handleInputChange}
              />

              {/* // I want a checkbox here saying "Send Special Instructions along with the booking", this is ticked by default */}
              {/* <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 20, gap: 10 }}>
                <CheckBox
                  value={sendSpecialInstructions}
                  onValueChange={setSendSpecialInstructions}
                  color="#A8CF45"
                />
                <Text style={{ fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans', fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#333' }}>Add special instructions to the booking</Text>
              </View> */}

              {
                <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', marginTop: 20, gap: 10, padding: 10, borderRadius: 8, backgroundColor: '#f5f5f5' }} onPress={handleEditInstructions}>
                  <Text style={{ fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans', fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#e94d8b' }}>Instructions(Tap to edit) :  {instructions ? instructions : "No instructions available. Tap to add instructions."}</Text>
                </TouchableOpacity>
              }
            </View>

            <TouchableOpacity style={styles.submitButton} onPress={handleSubmit}>
              <Text style={styles.submitText}>Confirm Booking</Text>
            </TouchableOpacity>
          </View>
        )}
      </ScrollView>

      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Edit Instructions</Text>
            <TextInput
              style={[styles.input, { width: '100%', height: 120, textAlignVertical: 'top', padding: 10, fontSize: 16 }]}
              value={tempInstructions}
              onChangeText={setTempInstructions}
              multiline={true}
              numberOfLines={4}
            />
            <View style={styles.modalButtons}>
              <TouchableOpacity
                style={styles.button}
                onPress={async () => {
                  try {
                    await fetch(
                      `${API_PATHS.BASE_URL}${API_PATHS.EDIT_PARENT_DETAILS}`,
                      {
                        method: 'POST',
                        headers: {
                          'Authorization': `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          parentId: userId,
                          discription: tempInstructions,
                        }),
                      }
                    );
                    setModalVisible(false);
                    fetchUserData();
                    toast.success("Instructions updated successfully")
                  } catch (error) {
                    toast.error("Something went wrong while instructions")
                  }
                }}
              >
                <Text style={styles.buttonText}>Save</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.button, { backgroundColor: '#ccc' }]}
                onPress={() => setModalVisible(false)}
              >
                <Text style={styles.buttonText}>Cancel</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      <ToastContainer position="top-center" autoClose={3000} />
    </View>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: '#fff',
  },
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  content: {
    flex: 1,
    padding: 15,
  },
  header: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#333',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  planType: {
    fontSize: 20,
    color: '#666',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  planDetails: {
    fontSize: 18,
    color: '#444',
    marginBottom: 10,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  daysContainer: {
    backgroundColor: '#f5f5f5',
    padding: 10,
    borderRadius: 8,
    marginBottom: 15,
  },
  daysLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#666',
    marginBottom: 5,
  },
  daysText: {
    fontSize: 16,
    color: '#444',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  serviceType: {
    fontSize: 18,
    color: '#666',
    marginBottom: 10,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  sectionHeader: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 20,
    marginBottom: 15,
    color: '#333',
  },
  childContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f9f9f9',
    padding: 15,
    borderRadius: 10,
    marginBottom: 15,
  },
  profilePic: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginRight: 15,
  },
  childName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  childDetails: {
    fontSize: 14,
    color: '#666',
  },
  addressCard: {
    backgroundColor: '#fff',
    borderRadius: 10,
    marginBottom: 15,
  },
  addressTag: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 3,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  addressText: {
    fontSize: 14,
    color: '#777',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  startDate: {
    fontSize: 16,
    marginBottom: 10,
    color: '#444',
  },
  labelText: {
    color: '#666',
    fontWeight: 'bold',
  },
  inputContainer: {
    marginTop: 10,
    marginBottom: 20,
  },
  input: {
    height: 80,
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 10,
    fontSize: 16,
    textAlignVertical: 'top',
    backgroundColor: '#f9f9f9',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  submitButton: {
    backgroundColor: '#A8CF45',
    padding: 15,
    borderRadius: 10,
    alignItems: 'center',
    marginBottom: 30,
  },
  submitText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  regularText: {
    fontSize: 16,
    color: '#444',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    width: '55%',
    padding: 30,
    backgroundColor: '#fff',
    borderRadius: 10,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 18,
    marginBottom: 20,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#333'
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 15,
  },
  button: {
    flex: 1,
    padding: 12,
    marginHorizontal: 10,
    backgroundColor: '#A6CE39',
    alignItems: 'center',
    borderRadius: 8,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontWeight: 'bold',
  },

  // --- Booking preview ---
  previewHeading: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  previewSubHeading: {
    fontSize: 14,
    color: '#888',
    marginTop: 4,
    marginBottom: 16,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  topRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 14,
  },
  topRowItem: {
    flex: 1,
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 14,
    borderWidth: 1,
    borderColor: '#eee',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 5,
    elevation: 2,
  },
  cardLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#EE3897',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginBottom: 10,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 12,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 6,
  },
  infoLabel: {
    fontSize: 15,
    color: '#888',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  infoValue: {
    fontSize: 15,
    color: '#333',
    fontWeight: '600',
    textAlign: 'right',
    flexShrink: 1,
    marginLeft: 12,
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  dayHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  dayTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  dayPrice: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#8dc63f',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  chipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  dayChip: {
    backgroundColor: '#f0f9e0',
    borderRadius: 16,
    paddingVertical: 6,
    paddingHorizontal: 14,
    marginRight: 8,
    marginBottom: 8,
  },
  dayChipText: {
    fontSize: 14,
    color: '#5a8a1a',
    fontWeight: '600',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  kidRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f9f9f9',
    padding: 10,
    borderRadius: 10,
    marginBottom: 8,
  },
  kidAvatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    marginRight: 12,
    backgroundColor: '#eee',
  },
  kidName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  kidDetails: {
    fontSize: 13,
    color: '#777',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  addressRow: {
    marginBottom: 8,
  },
  grandTotalCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f0f9e0',
    borderRadius: 12,
    padding: 16,
    marginBottom: 14,
  },
  grandTotalText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5a8a1a',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  grandTotalAmount: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#8dc63f',
    fontFamily:
      Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
});

export default ConfirmBooking;
